module.exports = __webpack_public_path__ + "img/174038c.jpg";